// Section palette — mirrors QSSection in the Flutter app so web and mobile match.
export type SectionKey =
  | 'home' | 'payments' | 'grocery' | 'notes' | 'tunes' | 'videos'
  | 'chat' | 'manage' | 'profile' | 'documents' | 'calendar' | 'reports' | 'pma' | 'speed' | 'password' | 'settings';

export type SectionPalette = { a: string; b: string; label: string };

export const SECTION_COLORS: Record<SectionKey, SectionPalette> = {
  home: { a: '#6226A7', b: '#F6A938', label: 'Home' },
  payments: { a: '#11998E', b: '#38EF7D', label: 'Payments' },
  grocery: { a: '#FF9800', b: '#E65100', label: 'Grocery' },
  notes: { a: '#6226A7', b: '#B06AB3', label: 'Notes' },
  tunes: { a: '#4776E6', b: '#8E54E9', label: 'Tunes' },
  videos: { a: '#EB3349', b: '#F45C43', label: 'Videos' },
  chat: { a: '#00B4DB', b: '#0083B0', label: 'Chat' },
  manage: { a: '#373B44', b: '#4286F4', label: 'Manage' },
  profile: { a: '#0F766E', b: '#14B8A6', label: 'Profile' },
  documents: { a: '#CF1E52', b: '#FF6B8B', label: 'Documents' },
  calendar: { a: '#2563EB', b: '#60A5FA', label: 'Calendar' },
  reports: { a: '#0F766E', b: '#2DD4BF', label: 'Reports' },
  pma: { a: '#373B44', b: '#4286F4', label: 'PMA' },
  speed: { a: '#1E3A8A', b: '#2563EB', label: 'Speed' },
  password: { a: '#6226A7', b: '#B06AB3', label: 'Password' },
  settings: { a: '#373B44', b: '#4286F4', label: 'Settings' },
};

/** Maps a pathname to its section palette. */
export const sectionForPath = (pathname: string): SectionKey => {
  const p = pathname.toLowerCase();
  if (p.startsWith('/payments')) return 'payments';
  if (p.startsWith('/grocery')) return 'grocery';
  if (p.startsWith('/notes')) return 'notes';
  if (p.startsWith('/tunes')) return 'tunes';
  if (p.startsWith('/videos')) return 'videos';
  if (p.startsWith('/chat')) return 'chat';
  if (p.startsWith('/manage')) return 'manage';
  if (p.startsWith('/profile')) return 'profile';
  if (p.startsWith('/documents')) return 'documents';
  if (p.startsWith('/calendar')) return 'calendar';
  if (p.startsWith('/reports')) return 'reports';
  if (p.startsWith('/pma')) return 'pma';
  if (p.startsWith('/internet-speed')) return 'speed';
  if (p.startsWith('/password')) return 'password';
  if (p.startsWith('/settings')) return 'settings';
  return 'home';
};

/** Darker stop for banners so white text stays readable on light gradients (e.g. payments green). */
export const bannerGradient = (key: SectionKey) => {
  // Purple -> gold blends to a muddy brown without a middle stop, so give the home palette a magenta bridge.
  if (key === 'home') return 'linear-gradient(120deg, #2E0F5E 0%, #6226A7 35%, #B13FD6 68%, #F6A938 100%)';
  const { a, b } = SECTION_COLORS[key];
  return `linear-gradient(120deg, ${a} 0%, ${a} 30%, ${b} 100%)`;
};
